import React from 'react'
import { useDispatch } from 'react-redux'  
import { map } from 'lodash'
import AsyncSelectField from '../Formik/AsyncSelectField'
import { getAllLots } from '../../actions/parkingLotActions';

function LotSelect() {
  const dispatch = useDispatch()

  async function loadOptions(inputValues, callback) {
    dispatch(getAllLots())
      .then((res) => {
        const arr = map(res, (lot) => ({label: lot.name, value: lot.id}))
        callback(arr)
      })
  }
  
  return <AsyncSelectField name="lot" label="Vyberte parkoviště" loadOptions={loadOptions} />
} 

export default LotSelect;